import styled from "styled-components";

import {
  Container,
  ContainerSeparator,
  HorizontalStack,
  HeroVerticalStack,
} from "@components/Layout";
import { Headline, DropHead } from "@components/Text";
import { Button } from "@components/Buttons";
import { SOCIAL_ICONS } from "@components/Cards";

const BRAND_CREAM = "#F2E8CF";

const HeroContainer = styled(Container)`
  background:
    radial-gradient(circle at 18% 22%, rgba(104, 151, 120, 0.2), transparent 38%),
    radial-gradient(circle at 82% 78%, rgba(104, 151, 120, 0.16), transparent 42%),
    ${({ theme }) => theme.colors.bgColor};
`;

const Background = styled.img`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 90%;
  max-width: none;
  opacity: 0.88;
  animation: floatBg 8s ease-in-out infinite alternate;

  @media ${({ theme }) => theme.breakpoints.md} {
    left: auto;
    right: 0;
    transform: none;
    padding-right: 5%;
    animation: none;
  }

  @keyframes floatBg {
    from {
      transform: translateX(-50%) translateY(0px);
    }
    to {
      transform: translateX(-50%) translateY(-10px);
    }
  }
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
`

const SocialContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: ${BRAND_CREAM};
  transition: all 0.2s ease;

  svg {
    color: currentColor;
    fill: currentColor;
  }

  &:hover {
    background-color: rgba(242, 232, 207, 0.14);
    transform: translateY(-2px) scale(1.04);
  }
`;

const HeroButton = styled(Button)`
  color: ${BRAND_CREAM};
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover,
  &:active,
  &:focus {
    color: ${BRAND_CREAM};
    box-shadow: 0 18px 30px rgba(0, 0, 0, 0.34);
    transform: translateY(-1px);
  }
`;

const mainSocials = [
  {
    url: "https://twitter.com/bykusari",
    icon: SOCIAL_ICONS.TWITTER,
  },
  {
    url: "https://discord.gg/cKWpT7HGam",
    icon: SOCIAL_ICONS.DISCORD,
  },
  {
    url: "https://www.instagram.com/bykusari",
    icon: SOCIAL_ICONS.INSTAGRAM,
  },
];

const Home = () => {
  const handleClick = () => {
    window.location.href = "./#about";
  };

  return (
    <HeroContainer id="home">
      <Background src="/images/bg.svg" />
      <HorizontalStack>
        <HeroVerticalStack align="start">
          <Headline>Empowering <br/>Creativity</Headline>
          <DropHead>
          Our mission is to inspire future generations of creators to express themselves onchain, by collaborating with the global community of onchain artists.
          </DropHead>
          
          <SocialContainer>
            {mainSocials.map((social) => (
              <SocialIcon 
                key={social.url} 
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {social.icon}
              </SocialIcon>
            ))}
          </SocialContainer>

          <ButtonContainer>
            <HeroButton onClick={handleClick}>Learn more</HeroButton>
          </ButtonContainer>
        </HeroVerticalStack>
      </HorizontalStack>
      <ContainerSeparator />
    </HeroContainer>
  );
};

export default Home;
